/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { removeWorkspace, setActiveWorkspace, setIsNewWorkspace } from '../../../../../store/workspaces/workspaces/actions';
import { getModules } from '../../../../../store/workspaces/modules/actions';
import { run as runActions } from '../../../../../store/workspaces/workspaces/run';
import { WorkspaceButtonContainerStyled } from '../../styles';
import ContextMenuWorkspace from '../context/tab.context';
import CreateWorkspaceDialog from '../dialog/dialog.tab';
import store from 'src/store/store';
import { toast } from 'src/utils/notification';
import WorkspaceTabTextbox from './components/tab.textbox';
import { newTab } from 'src/interactions/events/newTab';
import { focusTab } from 'src/interactions/events/focusTab';
import { TabService } from 'src/api/services/workspaces/Service.tab';
import { setTabEnabled } from '../utils/enableTab';

const WorkspacesButtonBar = ({ workspaces }) => {
  const dispatch = useDispatch<any>();
  const [showDialog, setShowDialog] = useState(false);
  const [contextMenu, setContextMenu] = useState(null);
  const [selectedWorkspaceIndex, setSelectedWorkspaceIndex] = useState(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      const currentWorkspaces = store.getState().workspaces;

      if (currentWorkspaces.groups.length === 0) { toast.warning('Um Tabs nutzen zu können, benötigen Sie einen initialen Workspace. Bitte kontaktieren Sie Ihren Administrator.');

        const overlay = document.createElement('div');
        overlay.id = 'global-overlay';
        overlay.style.position = 'fixed';
        overlay.style.inset = '0';
        overlay.style.background = 'rgba(255, 255, 255, 0.05)';
        overlay.style.zIndex = '9999';
        overlay.style.pointerEvents = 'all';
        overlay.style.cursor = 'not-allowed';
        overlay.style.backdropFilter = 'blur(0.5px)';
        document.body.appendChild(overlay);
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const group = JSON.parse(localStorage.getItem('activeWorkspace') || '{}');
    if (group?.color) {
      document.documentElement.style.setProperty('--workspaceGroupColor', group.color);
    }
  }, [localStorage.getItem('activeWorkspace')]);

  const handleTabClick = async (workspace, index) => {
    setTabEnabled(null, null, true);
    localStorage.setItem('selectedElements', JSON.stringify([]));
    await dispatch(setActiveWorkspace(index));

    if (workspace.isNewTab) {
      await dispatch(getModules());
      await runActions(workspace.data.key, workspace.data.id, workspace.data);
      await dispatch(setIsNewWorkspace(index, false));
    }
  };

  const handleTabCloseClick = async (index) => {
    const currentTab = workspaces.instances[index];
    const tabService = new TabService();
    await tabService.deleteTab(currentTab?.uuid);
    await dispatch(removeWorkspace(index));
    const newIndex = index === 0 ? 0 : index - 1;
    await dispatch(setActiveWorkspace(newIndex));
    const newActiveWorkspace = index === 0 ? workspaces.instances.find((workspace) => workspace.isNewTab) : workspaces.instances[newIndex];

    if (newActiveWorkspace?.isNewTab) {
      const { key, id } = newActiveWorkspace.data;
      await runActions(key, id, newActiveWorkspace.data);
      await dispatch(setIsNewWorkspace(newIndex, false));
    }
  };

  return (
    <>
      {workspaces.instances.map((workspace, index) => {
        if (!workspace.isOpen) return null;

        return (
          <Draggable key={workspace.uuid} draggableId={workspace.uuid} index={index}>
            {(provided) => (
              <WorkspaceButtonContainerStyled
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                active={+workspace.isActive}
                id={`workspace-cm-target-${workspace.uuid}`}
                data-id={workspace.uuid}
                onContextMenu={(e) => {
                  e.preventDefault();
                  setContextMenu({ index, x: e.pageX, y: e.pageY });
                  setSelectedWorkspaceIndex(index);
                }}
                style={{ ...provided.draggableProps.style, borderTop: `2.5px solid ${ JSON.parse(localStorage.getItem('activeWorkspace'))?.color || '#000'}`}}
                onClick={() => handleTabClick(workspace, index)}
              >
                <div className="workspace-tab-label workspace-button">
                  <WorkspaceTabTextbox workspace={workspace} />
                </div>
                {
                  workspaces.instances.length > 1 &&
                     <button
                       className="workspace-button e-icons e-close"
                       disabled={workspaces.instances.length <= 1}
                       onClick={(e) => { e.stopPropagation(); setTimeout(() => handleTabCloseClick(index), 500);}}
                     />
                }
              </WorkspaceButtonContainerStyled>
            )}
          </Draggable>
        );
      })}

      <button
        onClick={async () => {
          const { instances } = store.getState().workspaces;
          await newTab();
          await focusTab(instances.length);
        }}
        className="ml-1 mt-1 w-7 h-7 flex items-center justify-center rounded-full bg-transparent transition"
        title="Neuen Tab öffnen"
      >
        <span className="e-icons e-plus text-l" style={{ color: 'var(--backgroundContrast)' }} />
      </button>

      {contextMenu && (
        <ContextMenuWorkspace
          workspaceIndex={contextMenu.index}
          position={{ x: contextMenu.x, y: contextMenu.y }}
          onClose={() => setContextMenu(null)}
          showDialog={showDialog}
          setShowDialog={setShowDialog}
        />
      )}

      {showDialog && selectedWorkspaceIndex !== null && (
        <CreateWorkspaceDialog
          visible={showDialog}
          onClose={() => {
            setShowDialog(false);  
            setContextMenu(null);
            setSelectedWorkspaceIndex(null);
          }}
          workspaceIndex={selectedWorkspaceIndex}
          setShowDialog={setShowDialog}
        />
      )}
    </>
  );
};

WorkspacesButtonBar.propTypes = {
  workspaces: PropTypes.any,
};

export default WorkspacesButtonBar;
